module.exports = __webpack_public_path__ + "static/media/share-link.9d01bb3e.png";